import {useState} from 'react';

export default () => {
  const [visible, toggleVisible] = useState(false);
  const [content, setContent] = useState(null);
  const [props, setProps] = useState({size: 'md'});

  const toggleModal = ({
    content: modalContent = false,
    props: modalProps = false,
    isVisible = !visible,
  } = {}) => {
    if (modalContent) {
      setContent(modalContent);
    }
    if (modalProps) {
      setProps(modalProps);
    }
    toggleVisible(isVisible);
  };

  return {visible, toggleModal, content, props};
};
